<template>
  <div v-if="comType == 'UI'">
    <div
      class="recommend-content"
      :style="{
        position: 'relative',
        'border-radius': `${radius}px`,
        margin: `${marginTop}px ${marginRight}px ${marginBottom}px ${marginLeft}px`,
        padding: `${paddingTop}px ${paddingRight}px ${paddingBottom}px ${paddingLeft}px`,
        overflow: 'hidden',
        'background-color': backgroundColor,
      }"
    >
      <div
        class="title"
        :style="{
          color: textColor,
          'font-size': `${fontSize}px`,
        }"
      >
        {{ titleText }}
      </div>
      <div class="recommend-content-block">
        <div>
          <el-card
            :class="{
              type01: decorationShopType != 4,
              type00: decorationShopType == 4,
            }"
            :body-style="{ padding: '0px' }"
            v-for="(item, index) in goodsList"
            :key="index"
          >
            <div
              :class="{
                'single-row': decorationShopType == 4,
              }"
            >
              <div class="image">
                <img v-if="item.goodsImage" :src="item.goodsImage" />
              </div>
              <section v-if="decorationShopType == 4">
                <h3>{{ item.goodsName }}</h3>
                <p>服务时长: {{ item.serviceTime }}分钟</p>
                <div>
                  <span>￥{{ item.goodsPrice }}</span>
                  <span>￥{{ item.scribePrice }}</span>
                </div>
              </section>
              <section v-else>
                <h3>{{ item.goodsName }}</h3>
                <div>
                  <span>{{ item.goodsPrice }}</span> / {{ item.goodsUnit }}
                </div>
              </section>
              <div v-if="decorationShopType == 4" class="card-right">
                <span>{{ item.appointmentNum || "xx" }}人预约过</span
                ><i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="comType == 'config'">
    <el-form ref="form" label-width="100px" size="small">
      <div>
        <el-form-item label="名称">
          <el-input
            type="text"
            placeholder="请输入名称"
            size="small"
            v-model="titleTextValue"
            maxlength="8"
            show-word-limit
            clearable
            style="width: 180px"
          ></el-input>
        </el-form-item>
        <el-form-item label="字体大小">
          <el-radio-group v-model="fontSizeValue" size="small">
            <el-radio-button :label="12">小</el-radio-button>
            <el-radio-button :label="14">中</el-radio-button>
            <el-radio-button :label="18">大</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="字体颜色">
          <el-color-picker
            v-model="textColorValue"
            :predefine="predefineColors"
            size="small"
          ></el-color-picker>
        </el-form-item>
        <el-form-item label="背景颜色">
          <el-color-picker
            v-model="backgroundColorValue"
            :predefine="predefineColorsAlpha"
            size="small"
            show-alpha
          ></el-color-picker>
        </el-form-item>
      </div>
      <el-divider></el-divider>
      <div>
        <el-form-item label-width="10px">
          <el-button @click="openDialogFuc" type="primary" size="mini">
            <i class="el-icon-milk-tea"></i>添加{{
              decorationShopType == 4 ? "服务" : "商品"
            }}</el-button
          >
          <el-button @click="clearGoodsList" size="small" circle>
            <i class="el-icon-delete" size="small"></i
          ></el-button>
        </el-form-item>
        <el-table :data="goodsListValue" style="width: 100%">
          <el-table-column type="index" width="50"> </el-table-column>
          <el-table-column
            prop="goodsId"
            :label="`${decorationShopType == 4 ? '服务' : '商品'}ID`"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="goodsName"
            :label="`${decorationShopType == 4 ? '服务' : '商品'}名称`"
          >
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button
                @click="deleteGoods(scope.$index)"
                type="danger"
                size="small"
                circle
              >
                <i class="el-icon-delete" size="small"></i
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-divider></el-divider>
      <div>
        <el-form-item label="圆角">
          <div class="slider-block">
            <el-slider v-model="radiusValue" show-input :min="0" :max="50"> </el-slider>
            <div class="set-radius">
              <el-popover placement="top" width="160" trigger="hover">
                <radiusBox :radius="radiusValue"></radiusBox>
                <el-button slot="reference">可见性</el-button>
              </el-popover>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="上间距">
          <div class="slider-block">
            <el-slider v-model="marginTopValue" show-input :min="-100" :max="100">
            </el-slider>
          </div>
        </el-form-item>
        <el-form-item label="下间距">
          <div class="slider-block">
            <el-slider v-model="marginBottomValue" show-input :min="0" :max="100">
            </el-slider>
          </div>
        </el-form-item>
        <el-form-item label="左间距">
          <div class="slider-block">
            <el-slider v-model="marginLeftValue" show-input :min="0" :max="100">
            </el-slider>
          </div>
        </el-form-item>
        <el-form-item label="右间距">
          <div class="slider-block">
            <el-slider v-model="marginRightValue" show-input :min="0" :max="100">
            </el-slider>
          </div>
        </el-form-item>
        <el-form-item label="上内间距">
          <div class="slider-block">
            <el-slider v-model="paddingTopValue" show-input :min="0" :max="100">
            </el-slider>
          </div>
        </el-form-item>
        <el-form-item label="下内间距">
          <div class="slider-block">
            <el-slider v-model="paddingBottomValue" show-input :min="0" :max="100">
            </el-slider>
          </div>
        </el-form-item>
        <el-form-item label="左内间距">
          <div class="slider-block">
            <el-slider v-model="paddingLeftValue" show-input :min="0" :max="100">
            </el-slider>
          </div>
        </el-form-item>
        <el-form-item label="右内间距">
          <div class="slider-block">
            <el-slider v-model="paddingRightValue" show-input :min="0" :max="100">
            </el-slider>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <dialog-sel-goods-multiple ref="selGoods" @confirmSelGoods="confirmSelGoods">
    </dialog-sel-goods-multiple>
  </div>
</template>

<script>
import dialogSelGoodsMultiple from "@/components/dialogSelGoodsMultiple";
import radiusBox from "@/components/appltDecoration/radiusBox";
import { comMixins } from "@/mixins/comMixins";

export default {
  mixins: [comMixins],
  name: "comRecommendedProducts",
  components: {
    dialogSelGoodsMultiple,
    radiusBox,
  },
  data() {
    return {};
  },
  props: {
    comType: {
      type: String,
      default: "UI",
    },
    marginTop: {
      type: Number,
      default: 10,
    },
    marginRight: {
      type: Number,
      default: 10,
    },
    marginBottom: {
      type: Number,
      default: 10,
    },
    marginLeft: {
      type: Number,
      default: 10,
    },
    paddingTop: {
      type: Number,
      default: 10,
    },
    paddingRight: {
      type: Number,
      default: 10,
    },
    paddingBottom: {
      type: Number,
      default: 10,
    },
    paddingLeft: {
      type: Number,
      default: 10,
    },
    radius: {
      type: Number,
      default: 8,
    },
    textColor: {
      type: String,
      default: "rgb(51, 51, 51)",
    },
    fontSize: {
      type: Number,
      default: 14,
    },
    titleText: {
      type: String,
      default: () => {
        return `推荐${this.decorationShopType == 4 ? "服务" : "商品"}`;
      },
    },
    backgroundColor: {
      type: String,
      default: "rgb(255, 255, 255)",
    },
    goodsList: {
      type: Array,
      default: [
        // {
        //   goodsImage: "",
        //   goodsName: "蛋糕",
        //   goodsId: 49,
        //   goodsPrice: 25,
        //   goodsUnit: "份",
        // },
      ],
    },
  },
  computed: {
    titleTextValue: {
      get() {
        return this.titleText;
      },
      set(val) {
        this.$emit(`update:titleText`, val);
      },
    },
    textColorValue: {
      get() {
        return this.textColor;
      },
      set(val) {
        this.$emit(`update:textColor`, val);
      },
    },
    backgroundColorValue: {
      get() {
        return this.backgroundColor;
      },
      set(val) {
        this.$emit(`update:backgroundColor`, val);
      },
    },
    fontSizeValue: {
      get() {
        return this.fontSize;
      },
      set(val) {
        this.$emit(`update:fontSize`, val);
      },
    },
    goodsListValue: {
      get() {
        return this.goodsList;
      },
      set(val) {
        this.$emit(`update:goodsList`, val);
      },
    },
    radiusValue: {
      get() {
        return this.radius;
      },
      set(val) {
        this.$emit(`update:radius`, val);
      },
    },
    marginTopValue: {
      get() {
        return this.marginTop;
      },
      set(val) {
        this.$emit(`update:marginTop`, val);
      },
    },
    marginRightValue: {
      get() {
        return this.marginRight;
      },
      set(val) {
        this.$emit(`update:marginRight`, val);
      },
    },
    marginBottomValue: {
      get() {
        return this.marginBottom;
      },
      set(val) {
        this.$emit(`update:marginBottom`, val);
      },
    },
    marginLeftValue: {
      get() {
        return this.marginLeft;
      },
      set(val) {
        this.$emit(`update:marginLeft`, val);
      },
    },
    paddingTopValue: {
      get() {
        return this.paddingTop;
      },
      set(val) {
        this.$emit(`update:paddingTop`, val);
      },
    },
    paddingRightValue: {
      get() {
        return this.paddingRight;
      },
      set(val) {
        this.$emit(`update:paddingRight`, val);
      },
    },
    paddingBottomValue: {
      get() {
        return this.paddingBottom;
      },
      set(val) {
        this.$emit(`update:paddingBottom`, val);
      },
    },
    paddingLeftValue: {
      get() {
        return this.paddingLeft;
      },
      set(val) {
        this.$emit(`update:paddingLeft`, val);
      },
    },
  },
  methods: {
    openDialogFuc() {
      console.log("openDialog");
      let list = this.goodsList.map((val) => {
        return val.goodsId;
      });
      this.$refs.selGoods.openDialog(list);
    },
    confirmSelGoods(list) {
      console.log(list);
      this.goodsListValue = list.map((val) => {
        return this.decorationShopType == 4
          ? {
              goodsImage: val.goodsImage,
              goodsName: val.goodsName,
              goodsId: val.goodsId,
              goodsPrice: val.retailPrice,
              scribePrice: val.scribePrice,
              serviceTime: val.serviceTime,
              appointmentNum: val.appointmentNum,
            }
          : {
              goodsImage: val.goodsImage,
              goodsName: val.goodsName,
              goodsId: val.goodsId,
              goodsPrice: val.retailPrice,
              goodsUnit: val.unit,
            };
      });
    },
    deleteGoods(index) {
      console.log(index);
      this.goodsListValue.splice(index, 1);
    },
    clearGoodsList() {
      this.$confirm(`确定清空${this.decorationShopType == 4 ? "服务" : "商品"}吗?`, "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(({ value }) => {
          this.goodsListValue = [];
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="less">
.recommend-content .title {
  padding: 0 10px;
  padding-top: 10px;
}

.recommend-content .recommend-content-block > div {
  padding: 10px 10px 0 10px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.recommend-content .recommend-content-block > div .el-card {
  position: relative;
  z-index: 4;
  flex: 1;
  cursor: move;
  margin: 0 10px 10px 0;
}

.recommend-content .recommend-content-block > div .el-card.type00 {
  min-width: 100%;
  max-width: 100%;
  .single-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .image {
      min-width: 110px;
      width: 110px;
      height: 90px;
      border-radius: 6px;
      overflow: hidden;
      img {
        object-fit: cover;
        height: 100%;
      }
    }
    section {
      p {
        color: #aaa;
        white-space: nowrap;
        font-size: 12px;
        margin-bottom: 2px;
      }
      div {
        span {
          font-size: 16px;
          &:last-child {
            text-decoration: line-through;
            color: #ccc;
            font-weight: 400;
            margin-left: 10px;
          }
        }
      }
    }
    .card-right {
      display: flex;
      justify-content: flex-end;
      padding-right: 2px;
      span {
        font-size: 12px;
        vertical-align: middle;
        color: #aaa;
        margin-top: -2px;
        white-space: nowrap;
      }
    }
  }
}

.recommend-content .recommend-content-block > div .el-card.type01 {
  min-width: 47%;
  max-width: 49%;
}

.recommend-content .recommend-content-block > div .el-card.type01:nth-child(2n) {
  margin-right: 0;
}

.recommend-content .recommend-content-block > div .el-card .image {
  width: 100%;
  min-width: 100%;
  min-height: 100px;
  background-color: #f5f5f5;
}

.recommend-content .recommend-content-block > div .el-card .image img {
  display: block;
  min-width: 100%;
}

.recommend-content .recommend-content-block > div .el-card section {
  padding: 10px;
}

.recommend-content .recommend-content-block > div .el-card section h3 {
  font-weight: 700;
  margin-bottom: 5px;
  white-space: nowrap;
}

.recommend-content .recommend-content-block > div .el-card section span {
  // color: #409eff;
  color: #f56c6c;
  font-size: 18px;
  font-weight: 700;
}

.recommend-content .recommend-content-block > div .el-card .shop-card {
  overflow: hidden;
}

.recommend-content .recommend-content-block > div .el-card .shop-card .image {
  width: 100px;
  min-width: auto;
  height: 100px;
  float: left;
}

.recommend-content .recommend-content-block > div .el-card .shop-card .image img {
  display: block;
  min-width: auto;
  width: 100%;
  height: 100%;
}

.recommend-content .recommend-content-block > div .el-card .shop-card section {
  float: left;
}

.recommend-content .recommend-content-block > div .el-card .shop-card section h3 {
  font-weight: 400;
  margin-bottom: 5px;
}
.el-card .el-card__body {
  padding: 0;
  flex: 1;
  overflow: hidden;
}
img:not(.notFull img) {
  width: 100%;
}
</style>
